<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="pgepubid00001">
<h2 class="nobreak">CONTENTS</h2>
</div>
<table class="calibre12" summary="">
<tbody class="calibre13"><tr class="calibre14"><td class="tdr"><span class="small">CHAPTER</span></td>
<td class="tdr" colspan="2"> <span class="small">PAGE</span></td>
</tr>
<tr class="calibre14"><td class="tdr">I</td>
<td class="calibre16"> <span class="smcap">April’s Father</span></td>
<td class="tdr"><a href="#/Text/Section0003">        11</a></td>
</tr>
<tr class="calibre14"><td class="tdr">II</td>
<td class="calibre16"> <span class="smcap">April’s Son</span></td>
<td class="tdr"><a href="#/Text/Section0004#Page_21">        21</a></td>
</tr>
<tr class="calibre14"><td class="tdr">III</td>
<td class="calibre16"> <span class="smcap">Cousin Big Sue</span></td>
<td class="tdr"><a href="#/Text/Section0005#Page_40">         40</a></td>
</tr>
<tr class="calibre14"><td class="tdr">IV</td>
<td class="calibre16"> <span class="smcap">Julia</span></td>
<td class="tdr"><a href="#/Text/Section0006#Page_52">         52</a></td>
</tr>
<tr class="calibre14"><td class="tdr">V</td>
<td class="calibre16"> <span class="smcap">Blue Brook</span></td>
<td class="tdr"><span href="#/Text/Section0007#Page_57" title="Link target outside of Sample">         57</span></td>
</tr>
<tr class="calibre14"><td class="tdr">VI</td>
<td class="calibre16"> <span class="smcap">Uncle Bill</span></td>
<td class="tdr"><span href="#/Text/Section0008#Page_66" title="Link target outside of Sample">         66</span></td>
</tr>
<tr class="calibre14"><td class="tdr">VII</td>
<td class="calibre16"> <span class="smcap">A Birth-Night Supper</span></td>
<td class="tdr"><span href="#/Text/Section0009#Page_73" title="Link target outside of Sample">         73</span></td>
</tr>
<tr class="calibre14"><td class="tdr">VIII</td>
<td class="calibre16"> <span class="smcap">The Premises</span></td>
<td class="tdr"><span href="#/Text/Section0010#Page_84" title="Link target outside of Sample">         84</span></td>
</tr>
<tr class="calibre14"><td class="tdr">IX</td>
<td class="calibre16"> <span class="smcap">Saturday Afternoon</span></td>
<td class="tdr"><span href="#/Text/Section0011#Page_89" title="Link target outside of Sample">         89</span></td>
</tr>
<tr class="calibre14"><td class="tdr">X</td>
<td class="calibre16"> <span class="smcap">The Barnyard</span></td>
<td class="tdr"><span href="#/Text/Section0012#Page_100" title="Link target outside of Sample">        100</span></td>
</tr>
<tr class="calibre14"><td class="tdr">XI</td>
<td class="calibre16"> <span class="smcap">Hunting ’Possums and Turkeys</span></td>
<td class="tdr"><span href="#/Text/Section0013#Page_129" title="Link target outside of Sample">        129</span></td>
</tr>
<tr class="calibre14"><td class="tdr">XII</td>
<td class="calibre16"> <span class="smcap">Duck-Hunting</span></td>
<td class="tdr"><span href="#/Text/Section0014#Page_138" title="Link target outside of Sample">        138</span></td>
</tr>
<tr class="calibre14"><td class="tdr">XIII</td>
<td class="calibre16"> <span class="smcap">The Quilting</span></td>
<td class="tdr"><span href="#/Text/Section0015#Page_159" title="Link target outside of Sample">        159</span></td>
</tr>
<tr class="calibre14"><td class="tdr">XIV</td>
<td class="calibre16"> <span class="smcap">Church</span></td>
<td class="tdr"><span href="#/Text/Section0016#Page_180" title="Link target outside of Sample">        180</span></td>
</tr>
<tr class="calibre14"><td class="tdr">XV</td>
<td class="calibre16"> <span class="smcap">Field Work</span></td>
<td class="tdr"><span href="#/Text/Section0017#Page_199" title="Link target outside of Sample">        199</span></td>
</tr>
<tr class="calibre14"><td class="tdr">XVI</td>
<td class="calibre16"> <span class="smcap">Plowing</span></td>
<td class="tdr"><span href="#/Text/Section0018#Page_203" title="Link target outside of Sample">        203</span></td>
</tr>
<tr class="calibre14"><td class="tdr">XVII</td>
<td class="calibre16"> <span class="smcap">Hog-Killing</span></td>
<td class="tdr"><span href="#/Text/Section0019#Page_231" title="Link target outside of Sample">        231</span></td>
</tr>
<tr class="calibre14"><td class="tdr">XVIII</td>
<td class="calibre16"> <span class="smcap">Joy and April</span></td>
<td class="tdr"><span href="#/Text/Section0020#Page_268" title="Link target outside of Sample">        268</span></td>
</tr>
<tr class="calibre14"><td class="tdr">XIX</td>
<td class="calibre16"> <span class="smcap">At April’s House</span></td>
<td class="tdr"><span href="#/Text/Section0021#Page_287" title="Link target outside of Sample">        287</span></td>
</tr>
<tr class="calibre14"><td class="tdr">XX</td>
<td class="calibre16"> <span class="smcap">Seeking</span></td>
<td class="tdr"><span href="#/Text/Section0022#Page_308" title="Link target outside of Sample">               308</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?7ee6e316